module.exports = __webpack_public_path__ + "static/media/elanchi.2ba5fda8.jpg";